function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.364 6.538V4.231H1.636v2.307h6.137c0-.425.367-.769.817-.769h.82c.451 0 .817.341.817.769h6.137zm0 1.154h-6.137v.386c0 .424-.367.768-.817.768h-.82c-.451 0-.817-.34-.817-.768v-.386H1.636v5.77h14.728v-5.77zm-3.273-5h4.089c.453 0 .82.342.82.77V14.23c0 .425-.368.77-.82.77H.82c-.453 0-.82-.342-.82-.77V3.462c0-.425.368-.77.82-.77h4.09V.77c0-.425.367-.769.814-.769h6.552c.45 0 .815.341.815.77v1.922zM6.545 1.538v.77h4.91v-.77h-4.91z",
  fillRule: "evenodd"
});

var SvgBriefcase = function SvgBriefcase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 18 15",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBriefcase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Briefcase.4b754f15.svg";
export { ForwardRef as ReactComponent };